import Vue from 'vue';
import Router from 'vue-router';
import {getAuthToken, getUser, refresh} from '../storage.js'

import Home from '../pages/Home.vue';
import Contracts from '../pages/Contracts.vue';
import ContractsToCheck from '../pages/ContractsToCheck.vue';
import ContractAdd from '../pages/ContractAdd.vue';
import ContractDetails from '../pages/ContractDetails.vue';
import Establishments from '../pages/Establishments.vue';
import Login from '../pages/Login.vue';
import EstablishmentEdit from '../pages/EstablishmentEdit.vue';
import EstablishmentDetails from '../pages/EstablishmentDetails.vue';
import StatsEstablishments from '../pages/StatsEstablishments.vue';
import StatsEstablishment from '../pages/StatsEstablishment.vue';
import Logout from '../pages/Logout.vue';
import Export from '../pages/Export.vue';
import Musique from '../pages/Musique.vue';
import Connector from '../pages/Connecteur.vue';
import ConnectorTiti from '../pages/ConnecteurTitan.vue';
import MiniQuiz from '../pages/MiniQuiz.vue';
import Troubleshoot from '../pages/Troubleshoot.vue';
import TagHandler from '../pages/TagHandler.vue';
import TrainingDocs from '../pages/TrainingDocs.vue';
import changePassword from '../pages/changePassword.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/music',
      name: 'Musique',
      component: Musique,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/connector',
      name: 'Connector',
      component: Connector,
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '/titan',
      name: 'ConnectorTiti',
      component: ConnectorTiti,
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '/contracts',
      name: 'Contracts',
      component: Contracts,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/contractstocheck',
      name: 'ContractsToCheck',
      component: ContractsToCheck,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'book-keeper', 'seller'],
      },
    },
    {
      path: '/contract/add',
      name: 'ContractAdd',
      component: ContractAdd,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/tag/add',
      name: 'TagHandler',
      component: TagHandler,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/contract/:id/details',
      name: 'ContractDetails',
      component: ContractDetails,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/establishments',
      name: 'Establishments',
      component: Establishments,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/establishment/new',
      name: 'EstablishmentEdit',
      component: EstablishmentEdit,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/establishment/:id/details',
      name: 'EstablishmentDetails',
      component: EstablishmentDetails,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/troubleshoot',
      name: 'Troubleshooting',
      component: Troubleshoot,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/monitoring',
      name: 'StatsEstablishments',
      component: StatsEstablishments,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/monitoring/:id',
      name: 'StatsEstablishment',
      component: StatsEstablishment,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/miniquiz',
      name: 'MiniQuiz',
      component: MiniQuiz,
      meta: {
        requiresAuth: true,
        roles: ['trainer', 'admin', 'product'],
      },
    },
    // {
    //   path: '/unittests',
    //   name: 'UnitTests',
    //   component: UnitTests,
    //   meta: {
    //     requiresAuth: true,
    //     roles: ['admin', 'developer'],
    //   },
    // },
    {
      path: '/export',
      name: 'Export',
      component: Export,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'seller', 'trainer'],
      },
    },
    {
      path: '/trainingdocs',
      name: 'TrainingDocs',
      component: TrainingDocs,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'trainer'],
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/changePassword",
      component: changePassword,
      name: "changePassword",
    }
  ],

  fallback: false,
});


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = getAuthToken();
    if (token && token !== '') {
      if (!to.meta.roles) {
        // S'il n'y a pas de rôles définis pour cet url, on fait le process classique
        return next();
      }
      const role = getUser()?.access_type;
      if (!to.meta.roles.includes(role)) {
        // Si le role de l'user ne correspond pas
        return next({
          name: 'Home',
        });
      }
      next();
    } else if (to.name !== 'Login') {
      return next({
        name: 'Login',
      });
    }
  }
  refresh();
  return next();
});

// Fonction permettant de rediriger vers le login
router.toLogin = function() {
  if (this.currentRoute.name !== 'Login') this.push({name:"Login"});
}

export default router;
